module.exports = __webpack_public_path__ + "img/r.2607f654.jpg";